import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ContactMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.contact.contactMapperError"));

        Object.setPrototypeOf(this, ContactMapperError.prototype);
    }
}